// /*
//  *   File : otp-input.js
//  *   Author : https://evoqins.com
//  *   Description : OTP input component
//  *   Integrations : NA
//  *   Version : 1.0.1
// */

// //react
// import { useEffect, forwardRef, memo, useState, useRef } from "react";

// //styles
// import styles from "../../Style/Components/input.module.scss";

// const OTPInput = forwardRef((props, ref) => {
//   const [pin, setPin] = useState([]);
//   const otpInputRef = useRef(null);
//   const input_width = useRef(0);

//   // set width once
//   useEffect(() => {
//     if (otpInputRef.current) {
//       input_width.current = otpInputRef.current.clientWidth;
//     }
//   }, []);

//   // focus when needed
//   useEffect(() => {
//     const { focused_input, confirm_pin } = props;

//     if (ref && focused_input === 2 && confirm_pin.length < 4) {
//       ref.current.focus();
//     }
//   }, [props.focused_input, props.confirm_pin, ref]);

//   // sync pin and blur when finished
//   useEffect(() => {
//     const { confirm_pin, onBlur } = props;

//     setPin(confirm_pin);
//     if (ref && confirm_pin.length === 5) {
//       ref.current.blur();
//       onBlur();
//     }
//   }, [props.confirm_pin, props.onBlur, ref]);

//   const _preventDefaults = (e) => {
//     const key_code = e.keyCode || e.which;
//     const is_ctrl_pressed = e.ctrlKey || e.metaKey;

//     if (e.keyCode === 13) {
//       props.onKeyPress();
//     }

//     if (
//       key_code === 9 || // Tab key
//       (is_ctrl_pressed &&
//         (key_code === 65 || // A
//           key_code === 67 || // C
//           key_code === 88 || // X
//           key_code === 86)) // V
//     ) {
//       e.preventDefault();
//     }

//     if (
//       (key_code >= 48 && key_code <= 57) || // 0-9
//       (key_code >= 96 && key_code <= 105) || // Numpad 0-9
//       key_code === 8 || // Backspace
//       (key_code >= 37 && key_code <= 40) // Arrow keys
//     ) {
//       // Allow
//     } else {
//       e.preventDefault();
//     }
//   };

//   return (
//     <>
//       {props.label && (
//         <label
//           className={`${
//             props.labelStyle ? props.labelStyle : "e-font-weight-500 e-font-14 "
//           } e-text-black e-primary-font-poppins pb-2`}
//         >
//           {props.label}
//           {props.require && <span className="text-danger">*</span>}
//         </label>
//       )}
//       <div className={`${styles.e_otp_wrapper} h-64px user-select-none`}>
//         <input
//           style={{ width: input_width.current }}
//           type="text"
//           ref={ref}
//           id={props.id}
//           value={props.value}
//           spellCheck={props.spellCheck}
//           className="mb-0 e-caret-color-transparent"
//           onFocus={props.onFocus}
//           onBlur={props.onBlur}
//           onChange={props.onChange}
//           onKeyDown={_preventDefaults}
//           autoComplete="off"
//           autoFocus={props.autoFocus}
//           tabIndex={props.tabIndex}
//         />

//         <label ref={otpInputRef} className="d-flex column-gap-3">
//           <div
//             className={`justify-content-center align-items-center w-64px h-64px e-font-weight-500 e-font-16 e-inline-flex e-primary-font-poppins
//                   ${
//                     props.focused_input === 2
//                       ? "e-border-1px-blue e-drop-shadow-black"
//                       : "e-border-1px-silver"
//                   }`}
//           >
//             {pin.length !== 0 ? (
//               <span className="pt-1 e-text-egyptian-blue">*</span>
//             ) : (
//               <span className="pt-2"></span>
//             )}
//           </div>
//           <div
//             className={`justify-content-center align-items-center w-64px h-64px e-font-weight-500 e-font-16 e-inline-flex e-primary-font-poppins
//                   ${
//                     props.focused_input === 2 && pin.length >= 2
//                       ? "e-border-1px-blue e-drop-shadow-black"
//                       : "e-border-1px-silver"
//                   }`}
//           >
//             {pin.length >= 2 ? (
//               <span className="pt-1 e-text-egyptian-blue">*</span>
//             ) : (
//               <span className="pt-2"></span>
//             )}
//           </div>
//           <div
//             className={`justify-content-center align-items-center w-64px h-64px e-font-weight-500 e-font-16 e-inline-flex e-primary-font-poppins
//                  ${
//                    props.focused_input === 2 && pin.length >= 3
//                      ? "e-border-1px-blue e-drop-shadow-black"
//                      : "e-border-1px-silver"
//                  }`}
//           >
//             {pin.length >= 3 ? (
//               <span className="pt-1 e-text-egyptian-blue">*</span>
//             ) : (
//               <span className="pt-2"></span>
//             )}
//           </div>
//           <div
//             className={`justify-content-center align-items-center w-64px h-64px e-font-weight-500 e-font-16 e-inline-flex e-primary-font-poppins 
//                 ${
//                   props.focused_input === 2 && pin.length >= 4
//                     ? "e-border-1px-blue e-drop-shadow-black"
//                     : "e-border-1px-silver"
//                 }`}
//           >
//             {pin.length >= 4 ? (
//               <span className="pt-1 e-text-egyptian-blue">*</span>
//             ) : (
//               <span className="pt-2"></span>
//             )}
//           </div>
//         </label>

//         {/* Error message */}
//         {props.error && (
//           <p className="mb-0 text-danger e-font-12  e-font-weight-400 e-primary-font-poppins">
//             {props.error}
//           </p>
//         )}
//       </div>
//     </>
//   );
// });

// OTPInput.defaultProps = {
//   onKeyPress: () => {},
//   className: null,
//   error: "",
// };

// export default memo(OTPInput);


/*
 *   File : otp-input.js
 *   Author : https://evoqins.com
 *   Description : OTP input component
 *   Integrations : NA
 *   Version : 1.0.1
*/

//react
import { useEffect, forwardRef, memo, useState, useRef } from "react";

//styles
import styles from "../../Style/Components/input.module.scss";

const OTPInput = forwardRef((props, ref) => {
  const {
    confirm_pin,
    focused_input,
    onBlur,
    onFocus,
    onChange,
    onKeyPress,
    label,
    labelStyle,
    require,
    id,
    spellCheck,
    autoFocus,
    tabIndex,
    value,
    error,
  } = props;

  const [pin, setPin] = useState([]);
  const otpInputRef = useRef(null);
  const input_width = useRef(0);

  // set width once
  useEffect(() => {
    if (otpInputRef.current) {
      input_width.current = otpInputRef.current.clientWidth;
    }
  }, []);

  // focus when needed
  useEffect(() => {
    if (ref && focused_input === 2 && confirm_pin.length < 4) {
      ref.current.focus();
    }
  }, [focused_input, confirm_pin, ref]);

  // sync pin and blur when finished
  useEffect(() => {
    setPin(confirm_pin);
    // if (ref && confirm_pin.length === 5) {
    //   ref.current.blur();
    //   onBlur();
    // }
  }, [confirm_pin, ref, onBlur]);

  const _preventDefaults = (e) => {
    const key_code = e.keyCode || e.which;
    const is_ctrl_pressed = e.ctrlKey || e.metaKey;

    if (e.keyCode === 13) {
      onKeyPress();
    }

    if (
      key_code === 9 || // Tab key
      (is_ctrl_pressed &&
        (key_code === 65 || // A
          key_code === 67 || // C
          key_code === 88 || // X
          key_code === 86)) // V
    ) {
      e.preventDefault();
    }

    if (
      (key_code >= 48 && key_code <= 57) || // 0-9
      (key_code >= 96 && key_code <= 105) || // Numpad 0-9
      key_code === 8 || // Backspace
      (key_code >= 37 && key_code <= 40) // Arrow keys
    ) {
      // Allow
    } else {
      e.preventDefault();
    }
  };

  return (
    <>
      {label && (
        <label
          className={`${
            labelStyle ? labelStyle : "e-font-weight-500 e-font-14 "
          } e-text-black e-primary-font-poppins pb-2`}
        >
          {label}
          {require && <span className="text-danger">*</span>}
        </label>
      )}
      <div className={`${styles.e_otp_wrapper} h-64px user-select-none`}>
        <input
          style={{ width: input_width.current }}
          type="text"
          ref={ref}
          id={id}
          value={value}
          spellCheck={spellCheck}
          className="mb-0 e-caret-color-transparent"
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          onKeyDown={_preventDefaults}
          autoComplete="off"
          autoFocus={autoFocus}
          tabIndex={tabIndex}
        />

        <label ref={otpInputRef} className="d-flex column-gap-3">
          <div
            className={`justify-content-center align-items-center w-64px h-64px e-font-weight-500 e-font-16 e-inline-flex e-primary-font-poppins
                  ${
                    focused_input === 2
                      ? "e-border-1px-blue e-drop-shadow-black"
                      : "e-border-1px-silver"
                  }`}
          >
            {pin.length !== 0 ? (
              <span className="pt-1 e-text-egyptian-blue">*</span>
            ) : (
              <span className="pt-2"></span>
            )}
          </div>
          <div
            className={`justify-content-center align-items-center w-64px h-64px e-font-weight-500 e-font-16 e-inline-flex e-primary-font-poppins
                  ${
                    focused_input === 2 && pin.length >= 2
                      ? "e-border-1px-blue e-drop-shadow-black"
                      : "e-border-1px-silver"
                  }`}
          >
            {pin.length >= 2 ? (
              <span className="pt-1 e-text-egyptian-blue">*</span>
            ) : (
              <span className="pt-2"></span>
            )}
          </div>
          <div
            className={`justify-content-center align-items-center w-64px h-64px e-font-weight-500 e-font-16 e-inline-flex e-primary-font-poppins
                 ${
                   focused_input === 2 && pin.length >= 3
                     ? "e-border-1px-blue e-drop-shadow-black"
                     : "e-border-1px-silver"
                 }`}
          >
            {pin.length >= 3 ? (
              <span className="pt-1 e-text-egyptian-blue">*</span>
            ) : (
              <span className="pt-2"></span>
            )}
          </div>
          <div
            className={`justify-content-center align-items-center w-64px h-64px e-font-weight-500 e-font-16 e-inline-flex e-primary-font-poppins 
                ${
                  focused_input === 2 && pin.length >= 4
                    ? "e-border-1px-blue e-drop-shadow-black"
                    : "e-border-1px-silver"
                }`}
          >
            {pin.length >= 4 ? (
              <span className="pt-1 e-text-egyptian-blue">*</span>
            ) : (
              <span className="pt-2"></span>
            )}
          </div>
        </label>

        {/* Error message */}
        {error && (
          <p className="mb-0 text-danger e-font-12  e-font-weight-400 e-primary-font-poppins">
            {error}
          </p>
        )}
      </div>
    </>
  );
});

OTPInput.defaultProps = {
  onKeyPress: () => {},
  className: null,
  error: "",
};

export default memo(OTPInput);
